module.exports = function(obj) {
obj || (obj = {});
var __t, __p = '';
with (obj) {
__p += '<p>\n  ' +
((__t = ( I18n.t('uploader.product_tagging_search.empty') )) == null ? '' : __t) +
'\n</p>\n';

}
return __p
}